import { render, staticRenderFns } from "./NavigationDrawerNavItem.vue?vue&type=template&id=4d84badd&scoped=true"
import script from "./NavigationDrawerNavItem.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerNavItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerNavItem.vue?vue&type=style&index=0&id=4d84badd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d84badd",
  null
  
)

export default component.exports